import Image from "next/image";
import React from "react";

export default function FlagIcon({ flag }: { flag: string }) {
	return (
		<Image
			src={`${process.env.NEXT_PUBLIC_FLAG_SVG_URL}/flag/${flag}.webp`}
			alt={`${flag.toUpperCase()} flag`}
			title={`${flag.toUpperCase()} flag`}
			width={30}
			height={20}
			className="border-[1px]"
		/>
	);
}
